export const data1 = [
  {
    title: "What's Coderblock?",
    text: "Coderblock is the metaverse gaming platform that allows users to share and monetize their unique immersive games. A virtual place where you can create your identity, live amazing in-game adventures, climb the ranks, buy, customize and earn from your lands for a world of opportunities!",
  },
  {
    title: "What can I do inside Coderblock?",
    text: "You can create your own experiences inside your land: use the Builder to customize the look and the experiences inside it. You can join quests and adventures to level up and soon you'll be able to play the first chapter of our Game.",
  },
  {
    title: "What are Lands?",
    text: "Lands are virtual terrains inside Coderblock Open World. Each land is represented by a ERC-721 token, NFT available for purchase and trade.",
  },
];
export const data2 = [
  {
    title: "How can I buy Lands?",
    text: "You can get Coderblock Lands during the official sale events, using your credit card or your cryptowallet, or by making an offer for them on Opensea.",
  },
  {
    title: "How can I earn from my lands?",
    text: "You can earn from your creations with Coderblock ADS, becoming a Publisher and earning a monthly revenue based on your visitors, and with the Creator Marketplace, thanks to the match with our partner companies that will allow you to make profits from your sponsored experiences.",
  },
  {
    title: "Can I choose the location of my lands?",
    text: "Yes, unlike last pre-sale season, you can now choose the exact location of the plots you want to get by selecting them directly from the map.",
  },
];
